import React from 'react';

import { OptionType } from '@/typings/common';
import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarBattery,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';

function BatteryTypeFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedBattery =
    useTypedSelector(getSelectedFilters).selectedParams.selectedBattery;

  const batteryOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'batteryTypes'
  );

  const handleChangeBattery = (battery: OptionType) => {
    dispatch(setCarBattery(handleChangeMultiSelect(battery, selectedBattery)));
    dispatch(setPage(1));
  };

  const handleClearBattery = () => {
    dispatch(setCarBattery([]));
    dispatch(setPage(1));
  };

  return (
    <StockFilterMultiSelect
      label="Батарея для электро"
      options={batteryOptions}
      selectedOptions={selectedBattery}
      onChange={handleChangeBattery}
      onClear={handleClearBattery}
    />
  );
}

export default BatteryTypeFilter;
